import { deleteGuidelines } from "Features/Learning/Guidelines/Utils/GuidelineUtils";
import Swal from "sweetalert2";
import { handleDeleteConfirmation } from "Utils/handleDelete";

export const handleDeleteGuideline = async (dispatch, id, setRefetch) => {
  handleDeleteConfirmation({
    dispatch,
    id,
    setRefetch,
    deleteAction: deleteGuidelines,
  });
}

export const handleEditGuideline = async (dispatch, item, setField) => {
  dispatch(setField({ field: 'isUpdate', value: true }));
  const fieldsToUpdate = ['title_group', 'day', 'items', 'membership_id', 'id'];
  fieldsToUpdate.forEach(field => {
    dispatch(setField({ field, value: item[field] }));
  });
}

export const handleCopy = (url) => {
  const link = document.createElement("textarea");
  link.value = url;
  document.body.appendChild(link);
  link.select();

  try {
    document.execCommand("copy");
    Swal.fire({
      title: "Copied!",
      text: "Link guideline berhasil dicopy",
      icon: "success",
      confirmButtonColor: '#3085d6',
    });
  } catch (err) {
    Swal.fire({
      title: "Error!",
      text: "Gagal menyalin link guideline",
      icon: "error",
      confirmButtonColor: '#3085d6',
    });
  }
  document.body.removeChild(link);
};